import React from "react";

const IconEmail = ({
  width = "25",
  height = "25",
  fill = "#ffffff",
  className = "",
}) => {
  return (
    <svg
      viewBox="0 0 32 32"
      width={width}
      height={height}
      className={className ? className : null}
      data-name="iconEmail"
    >
      <path
        fill={fill}
        d="M24.214 7.786h-16.429c-1.129 0-2.043 0.924-2.043 2.054l-0.010 12.321c0 1.129 0.924 2.054 2.054 2.054h16.429c1.129 0 2.054-0.924 2.054-2.054v-12.321c0-1.129-0.924-2.054-2.054-2.054v0zM24.214 11.893l-8.214 5.134-8.214-5.134v-2.054l8.214 5.134 8.214-5.134v2.054z"
      />
    </svg>
  );
};

export default IconEmail;
